import { productUnitApi } from "../api";

const ProductUnitService = {
    /**
     * Obtener todas las unidades de medida.
     */
    getAll: async () => {
        try {
            const response = await productUnitApi.fetchAll();
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    /**
     * Obtener unidades activas para un menú desplegable.
     */
    getDropdown: async () => {
        try {
            const response = await productUnitApi.fetchCustom('/dropdown');
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    /**
     * Buscar unidad de medida por nombre.
     */
    findByName: async (name: string) => {
        try {
            const response = await productUnitApi.fetchCustom(`/search?name=${name}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    /**
     * Crear una nueva unidad de medida.
     */
    save: async (data: Object) => {
        try {
            const response = await productUnitApi.add(data);
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    /**
     * Actualizar el nombre de una unidad de medida.
     */
    update: async (id: number, data: Object) => {
        try {
            const response = await productUnitApi.modify(id, data);
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    /**
     * Activar o desactivar una unidad de medida.
     */
    deactivate: async (id: number) => {
        try {
            const response = await productUnitApi.patchCustom(`${id}/toggle-status`);
            return response.data;
        } catch (error) {
            throw error;
        }
    }

}

export default ProductUnitService;
